import ToggleSetting from "../../elements/buttons/toggleSetting.component.jsx";
import { useIntl } from "react-intl";
import { useEffect, useState } from "react";

export default function PushSettings({
  userAllowed,
  permissionAllowed,
  setSettingsProperties,
}) {
  const intl = useIntl();
  const [permissionText, setPermissionText] = useState(null);

  const handleChange = (e) => {
    setSettingsProperties({ pushMessages: { userAllowed: e.target.checked } });
  };

  useEffect(() => {
    if (permissionAllowed !== null && !permissionAllowed && userAllowed) {
      setPermissionText("System permission is denied");
    }
    if (permissionAllowed) {
      setPermissionText(null);
    }
  }, [permissionAllowed, userAllowed]);

  return (
    <div className="d-flex flex-column">
      {permissionText ? permissionText : null}
      <ToggleSetting
        settingTitle={intl.formatMessage({
          id: "settings.push.allowPushMessagesTitle",
        })}
        settingText={intl.formatMessage({
          id: "settings.push.allowPushMessagesText",
        })}
        onChange={handleChange}
        toggleValue={userAllowed}
      />
    </div>
  );
}
